import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import numberFormat from "ati-utils/numberFormat";

import { useStore } from "../../../../connect";

import strings from "../../../../locales/strings";

import styles from "./UserInformation.scss";

const cx = classnames.bind(styles);

const UserInformation = () => {
  const { profile } = useStore();

  let days = null;

  if (!profile.noProfile) {
    if (
      profile.user.guaranteed_payment &&
      profile.user.guaranteed_payment.remaining_days >= 0
    ) {
      days = profile.user.guaranteed_payment.remaining_days;
    } else if (
      !profile.payedServices.regular.isEmpty &&
      profile.payedServices.regular.remainingDays >= 0
    ) {
      days = profile.payedServices.regular.remainingDays;
    } else if (!profile.payedServices.unlimited.isEmpty) {
      let minDays = profile.payedServices.unlimited.list[0].remainingDays;

      profile.payedServices.unlimited.list.forEach((license) => {
        if (license.remainingDays < minDays) {
          minDays = license.remainingDays;
        }
      });

      days = minDays;
    }
  }

  let info;
  if (days !== null && days >= 0) {
    info = (
      <>
        <span
          className={cx("days", {
            expired: days <= 10 || profile.user.guaranteed_payment,
          })}
        >
          {days} {strings.days},
        </span>
        {numberFormat(profile.user.balance)} {strings.profile_atis}
      </>
    );
  } else if (profile.payedServices.unlimited.isEmpty) {
    info = strings.profile_freeUser;
  } else {
    // Этот вариант скорее всего никогда не будет обработан,
    // если с бэка не будут приходить отрицательные значения
    info = (
      <>
        {numberFormat(profile.user.balance)} {strings.profile_atis}
      </>
    );
  }

  return (
    <span className={cx("user-information")}>
      {profile.noProfile ? (
        <>
          <span className={cx("name")}>{strings.profile_yourContact}</span>
          <span className={cx("info", "is-unavailable")}>
            {strings.profile_serviceUnavailable}
          </span>
        </>
      ) : (
        <>
          <span className={cx("name")}>
            {profile.user?.contact?.name || strings.profile_yourContact}
          </span>
          <span className={cx("info")}>{info}</span>
        </>
      )}
    </span>
  );
};

export default observer(UserInformation);
